import React from "react";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Button from "antd/lib/button";
import FormattedMessage from "components/FormattedMessage";
import ProgressBar from "components/project/ProgressBar";
import Timer from "components/project/Timer";
import { formatMoney, formatPercentage } from "utils/formatters";

export interface Props {
  backgroundImageUrl?: string;
  requiredBudgetInCt: number;
  interestRateInPct?: number;
  contractDurationPeriods?: number;
  projectName: string;
  companyName?: string;
  characteristics: string[];
  investorCount: number;
  requiredMinBudgetInCt?: number;
  submittedAmountInCt: number;
  coFundingAmountInCt: number;
  endDateTime?: string;
  slug?: string;
  style?: React.CSSProperties;
  investProcessId?: string;
  backgroundColor?: string;
}

export default function ProjectListItem(props: Props): JSX.Element {
  return (
    <div
      onClick={() => (window.location.href = `/${props.slug}`)}
      style={{
        width: "100%",
        height: "100%",
        boxShadow: "rgba(0, 0, 0, 0.12) 0px 6px 16px",
        marginBottom: 24,
        borderRadius: 5,
        textAlign: "center",
        paddingBottom: 24,
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        ...props.style
      }}
    >
      <div>
        <Row
          style={{
            background: `linear-gradient(to bottom, rgba(0,0,0,0) 60%, rgba(0,0,0,0.8)), url(${props.backgroundImageUrl})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: 250,
            borderRadius: "5px 5px 0 0"
          }}
        >
          <Col style={{ width: "100%", height: "100%" }}>
            <Row
              style={{
                color: "white",
                fontSize: "1em",
                padding: "0 24px 6px 24px",
                position: "absolute",
                bottom: 0,
                width: "100%"
              }}
            >
              <Col span={10} style={{ textAlign: "left" }}>
                <b>{formatMoney(props.requiredBudgetInCt, 0)}</b>
              </Col>
              <Col span={7} style={{ textAlign: "center" }}>
                <b>{formatPercentage(props.interestRateInPct, 1)}</b>
              </Col>
              <Col span={7} style={{ textAlign: "right" }}>
                <b>
                  {props.contractDurationPeriods}&nbsp;
                  {props.contractDurationPeriods === 1 ? (
                    <FormattedMessage id="project_side_bar_year" />
                  ) : (
                    <FormattedMessage id="project_side_bar_years" />
                  )}
                </b>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style={{ padding: "6px 12px 6px 12px", fontSize: "1.2em", textAlign: "left" }}>
          <Col span={24} style={{ overflowWrap: "break-word" }}>
            <b>{props.projectName}</b>
          </Col>
        </Row>
        {props.companyName && (
          <Row style={{ padding: "0 12px 24px 12px", fontSize: "1.0em", overflowWrap: "break-word", textAlign: "left" }}>
            <Col span={24}>
              <i>{props.companyName}</i>
            </Col>
          </Row>
        )}
        <Row style={{ padding: "0 12px 12px 12px", textAlign: "left", marginBottom: -30 }}>
          <Col span={24}>
            <ul>
              {props.characteristics.map((item, index) => (
                <li key={index}>
                  <b>{item}</b>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </div>
      <div>
        <Row style={{ marginBottom: 1 }}>
          <Col span={24}>
            <Timer endDateTime={props.endDateTime} />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <ProgressBar
              investorCount={props.investorCount}
              requiredBudgetInCt={props.requiredBudgetInCt}
              requiredMinBudgetInCt={props.requiredMinBudgetInCt}
              submittedAmountInCt={props.submittedAmountInCt}
              coFundingAmountInCt={props.coFundingAmountInCt === 0 ? undefined : props.coFundingAmountInCt}
              strokeColor={props.backgroundColor}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Button type="primary" href={`/${props.slug}`} style={{ color: "#fff", backgroundColor: "#9BC55B", borderColor: "#9BC55B" }}>
              <FormattedMessage id="project_list_item_go_to_project" />
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
}
